import api from '@/store/api'
import { getField, updateField } from 'vuex-map-fields'

const state = {
	songs: {
		data: [],
		last_page: 0,
		to: 0,
		total: 0,
		from: 0
	},
	filter: {
		keyword: '',
		page: 1,
		count: 10,
		sort_by: '',
		theme_filter: []
	},
	form: {
		title: '',
		artist: '',
		theme: '',
		classification: {
			alpha: '',
			beta: '',
			delta: ''
		},
		music: null
	},
	errors: {
		title: '',
		artist: '',
		theme: '',
		classification: {
			alpha: '',
			beta: '',
			delta: ''
		},
		music: ''
	},
	progress: 0,
	isLoading: false
}

const mutations = {
	updateField
}

const actions = {
	async fetchSongs ({ state }, payload) {
		state.isLoading = true
		const { data, status } = await api('get', `list${payload}`)

		if (status) {
			state.songs.data = data.data.data
			state.filter.page = data.data.current_page
			state.songs.last_page = data.data.last_page
			state.songs.total = data.data.total
			state.songs.to = data.data.to
			state.songs.from = data.data.from
			state.filter.count = Number(data.data.per_page)
		} else {
			state.songs = []
		}
		state.isLoading = false
	},
	async uploadCSV ({ state, dispatch }, { form, callback, errCallback }) {
		state.isLoading = true

		const { data } = await api('post', 'temp-upload', form)
		const uploadCSVForm = new FormData()
		uploadCSVForm.set('file', data.data.server_name)
		uploadCSVForm.set('document_type', 'csv')

		const uploadProgress = (value) => {
			state.progress = (value.loaded / value.total) * 100
		}
		const { status } = await api('post', 'upload-csv', uploadCSVForm, true, uploadProgress)
		if (status) {
			dispatch('toggleBanner', {
				message: 'Music CSV has been successfully uploaded.',
				type: 'success'
			}, { root: true })
		} else {
			dispatch('toggleBanner', {
				message: 'Something went wrong',
				type: 'error'
			}, { root: true })
		}
		callback()
	},
	async create (_, payload) {
	},
	async view (_, payload) {
	}
}

const getters = {
	getField,
	songList: state => state.songs,
	isLoading: state => state.isLoading
}

export default {
	state,
	getters,
	mutations,
	actions,
	namespaced: true
}
